<script>
import { onMount } from 'svelte';

export let src;
export let i;
export let container;

let lazyImage;
let currentFrame;

let observer;

export function updateCurrentFrame() {
    if (!lazyImage) {
        removeObserver();
        return;
    }
    if (lazyImage.src == lazyImage.dataset.src) { // image already loaded
        removeObserver();
        return;
    }

    currentFrame = parseInt(container.style.getPropertyValue("--i"), 10);
    // is the slideshow at this photo or previous one? if yes, load highres image
    if (currentFrame != i && currentFrame != (i-1)) {
        return;
    }

    lazyImage.src = lazyImage.dataset.src;
    lazyImage.srcset = lazyImage.dataset.srcset;

    removeObserver();
}

function removeObserver() {
    observer.disconnect();
}

onMount(() => {
    observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
            updateCurrentFrame();
        });    
    });

    observer.observe(container, { attributes : true, attributeFilter : ['style'] });
});
</script>

<style>
img {
	width: 100%;
	width: calc(100%/var(--n));
	user-select: none;
	pointer-events: none;

	-webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
        -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadein 1s; /* Firefox < 16 */
            -ms-animation: fadein 1s; /* Internet Explorer */
            -o-animation: fadein 1s; /* Opera < 12.1 */
                    animation: fadein 1s;
}
</style>
{#if i == 0}
	<img src="{src}" alt="Photo {i}">
{:else}
	<img bind:this="{lazyImage}"
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEAAAICTAEAOw==" 
    data-src="{src}" 
    data-srcset="{src} 1x" 
    alt="Photo {i}">
{/if}
